"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpTypePicker = void 0;
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const OpType_1 = require("@opsbase/lib-op/OpType");
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useSelfActions_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelfActions/useSelfActions"));
const useOrgFindById_1 = __importDefault(require("@opsbase/react-gql-hooks/organisation/useOrgFindById"));
const useOrgUpdate_1 = __importDefault(require("@opsbase/react-gql-hooks/organisation/useOrgUpdate"));
const AddNewBar_1 = __importDefault(require("@opsbase/web-data-choosers/core/AddNewBar"));
const Vertical_1 = require("@opsbase/web-layout/Vertical");
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const Select_1 = __importDefault(require("@opsbase/web-ui/Select"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const makePicker_1 = __importDefault(require("../helpers/makePicker"));
exports.OpTypePicker = (0, makePicker_1.default)((props) => {
    var _a;
    const self = (0, useSelf_1.default)();
    const { updateSettings } = (0, useSelfActions_1.default)();
    const { data: org } = (0, useOrgFindById_1.default)({ variables: { id: self.organisationId } });
    const updateOrg = (0, useOrgUpdate_1.default)();
    const handleChange = (0, react_1.useCallback)(opTypes => {
        const patch = {
            opTypes,
        };
        updateOrg({
            id: org.id,
            patch: {
                settings: Object.assign({}, patch),
            },
        }, {
            optimisticResponse: {
                __typename: 'Mutation',
                updateOrg: Object.assign(Object.assign({ __typename: 'Organisation' }, org), { settings: Object.assign(Object.assign({}, org.settings), patch) }),
            },
        })
            .then(updatedOrg => {
            updateSettings(updatedOrg.settings);
        })
            .catch(doNothing_1.default);
    }, [org, updateSettings, updateOrg]);
    const handleAddNew = (0, react_1.useCallback)((newTitle) => __awaiter(void 0, void 0, void 0, function* () {
        handleChange(self.settings.opTypes.concat(new OpType_1.OpType(newTitle, newTitle)));
        props === null || props === void 0 ? void 0 : props.onChange(newTitle);
    }), [handleChange, (_a = self === null || self === void 0 ? void 0 : self.settings) === null || _a === void 0 ? void 0 : _a.opTypes, props]);
    return (react_1.default.createElement(Vertical_1.Vertical, null,
        react_1.default.createElement(Select_1.default, Object.assign({}, props),
            Object.values(self === null || self === void 0 ? void 0 : self.settings.opTypes).map(v => (react_1.default.createElement(MenuItem_1.default, { key: v.key, value: v.key },
                react_1.default.createElement(Text_1.default, null, v.title)))),
            (self === null || self === void 0 ? void 0 : self.isPrimary) && (react_1.default.createElement(AddNewBar_1.default, { addLabel: 'Create new optype', onAddNew: handleAddNew })))));
});
exports.default = exports.OpTypePicker;
